import React from "react";
import Headline from "../common/Headline";

const EmptyList = () => {
  return (
    <Headline size={2} level={2}>
      Keine Einträge vorhanden
    </Headline>
  );
};
export default EmptyList;
